import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "checkbox" ]

  selectAll() {
    this.#setAll(true)
  }

  selectUnconfirmed() {
    this.checkboxTargets.forEach((box) => {
      box.checked = box.dataset.unconfirmed === "true"
    })
  }

  clearAll() {
    this.#setAll(false)
  }

  #setAll(checked) {
    this.checkboxTargets.forEach((box) => {
      box.checked = checked
    })
  }
}
